import { Container } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useForgotPassword, useLogin } from '../hooks/useAuth';
import toast from 'react-hot-toast';
import { StyledTitle } from './Register.styled';
import { LoginForm } from '../components/forms/LoginForm';
import { ForgotPasswordModal } from '../components/modals/ForgotPasswordModal';
import { loginSchema } from '../utils/authUtils';
import { useAuth } from '../context/authContext';
import { useNavigate } from 'react-router-dom';
import { useAddQuizToStudent, useAddResolvedQuizToStudent } from '../hooks/useStudent';
import { META_DATA, ROLE } from '../utils/constants';
import { Helmet } from 'react-helmet-async';

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();
  const { loginUser, isLogining } = useLogin();
  const { forgotPassword } = useForgotPassword();
  const { addQuiz, isAdditingQuiz } = useAddQuizToStudent();
  const { addResolvedQuiz } = useAddResolvedQuizToStudent();

  const { title, description, keywords } = META_DATA?.login;  

  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });


  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard?tab=classroom');
    }      
  }, [isAuthenticated]);

  const handleChange = e => {
    const { name, value } = e.target;
    setFormData(prevData => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();

    try {
      await loginSchema.validateAsync(formData, { abortEarly: false });
      const userData = await loginUser(formData);
      if (userData?.user) {
        login(userData.user);              
        setFormData({
          email: '',
          password: '',
        });
        let pathNavigate = userData?.user?.role === ROLE.TEACHER ? "/dashboard?tab=classroom" : "/dashboard?tab=quiz";

        const idQuiz = localStorage.getItem('quizId');
        if (idQuiz) {
          await addQuiz({ idQuiz });
          localStorage.removeItem('quizId');
          pathNavigate = '/dashboard?tab=quiz';
        }
        const quizResult = JSON.parse(localStorage.getItem('quizResult'));
        if (quizResult) {
          await addResolvedQuiz(quizResult);
          localStorage.removeItem('quizResult');
          pathNavigate = '/dashboard?tab=quiz';
        }
        const redirectQuiz = localStorage.getItem('redirectQuiz');        
        if (redirectQuiz) {
          pathNavigate = redirectQuiz;
          localStorage.removeItem('redirectQuiz');
        }
        navigate(pathNavigate); 
      }
    } catch (error) {
      if (error.details) {
        const errorMessage = error.details
          .map(detail => detail.message)
          .join('\n');
        toast.error(errorMessage, { duration: 3000 });
      }
    }
  };

  const handleForgotPassword = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Helmet>
                <title>{title}</title>
                <meta name="keywords" content={keywords} />                
                <meta name="description" content={description} />
      </Helmet>

    <Container maxWidth="sm">
      <StyledTitle>
        Effettua l'accesso inserendo l'email e la password
        </StyledTitle>
      <LoginForm
        formData={formData}
        handleChange={handleChange}
        handleSubmit={handleSubmit}
        isLogining={isLogining}
        handleForgotPassword={handleForgotPassword}
      ></LoginForm>
      <ForgotPasswordModal
        open={openModal}
        onClose={handleCloseModal}
        forgotPassword={forgotPassword}
      ></ForgotPasswordModal>
    </Container>
    </>
  );
};

export default Login;